import {hoverDynamic} from './hover';
import {intRandom} from './_randNum';
import {shuffleArray} from './_shuffleArray';

export function bounceText() {
  const containers = document.querySelectorAll('.js-text-bounce-container');

  const is = (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      } else {
        entry.target.classList.remove('visible');
      }
    })
  }
  if(containers.length) {
    const observer = new IntersectionObserver(is);
    containers.forEach(c => {
      observer.observe(c);
    });
    containers.forEach(container => {
      const dataLabels = container.dataset.labels;
      if(dataLabels) {

        const isLink = container.dataset.link;
        const isViewport = (container.dataset.viewport !== undefined) ? container.dataset.viewport : false;
        const isRandColor = (container.dataset.randcolor !== undefined) ? container.dataset.randcolor : false;
        const maxLabels = (container.dataset.max !== undefined) ? container.dataset.max : 50;
        const minSpeed = (container.dataset.minSpeed !== undefined) ? container.dataset.minSpeed : 0.3;
        const maxSpeed = (container.dataset.maxSpeed !== undefined) ? container.dataset.maxSpeed : 1.5;
        const textColor = (container.dataset.labelTextcolor !== undefined) ? container.dataset.labelTextcolor : '';
        const bgColor = (container.dataset.labelBgcolor !== undefined) ? container.dataset.labelBgcolor : '';
        let showInterval = (container.dataset.interval !== undefined) ? container.dataset.interval : 1000;

        const labels = JSON.parse(dataLabels);
        let objects = [];
        let shuffledLabels = [];
        let currentIndex = 0;

        function createObject() {
          const label = shuffledLabels[currentIndex];
          let isReturn = false;
          if(objects.length) {
            const isExists = objects.find(e => e.label === label);
            if(isExists !== undefined) isReturn = true;
          }
          if(isReturn) return;

          const wH = window.innerHeight;
          const wW = window.innerWidth;
          const cW = container.clientWidth;
          const cH = container.clientHeight;

          let range = 0.1;
          // if(wW <= 768) {
          //   range = 0.15;
          //   showInterval = showInterval*2
          // }

          let centerX = ''
          let centerY = ''
          let rangeX = ''
          let rangeY = ''

          if(wH < cH && isViewport) {
            // スクロール位置を取得
            const scrollX = window.scrollX || window.pageXOffset;
            const scrollY = window.scrollY || window.pageYOffset;
            const scrollXR = scrollX + wW;
            const scrollYB = scrollY + wH;

            // コンテナの位置を取得
            const containerOffsetLeft = container.offsetLeft;
            const containerOffsetRight = containerOffsetLeft + cW;
            const containerOffsetTop = container.offsetTop;
            const containerOffsetBottom = containerOffsetTop + cH;

            // コンテナの現在のビューポートに対する位置を計算
            let winPosLeft = Math.max(containerOffsetLeft, scrollX);
            let winPosRight = Math.min(containerOffsetRight, scrollXR);
            let winPosTop = Math.max(containerOffsetTop, scrollY);
            let winPosBottom = Math.min(containerOffsetBottom, scrollYB);

            if(scrollX <= containerOffsetLeft) winPosRight = containerOffsetLeft + wW;
            if(scrollXR >= containerOffsetRight) winPosLeft = cW - wW;
            if(scrollY <= containerOffsetTop) winPosBottom = containerOffsetTop + wH;
            if(scrollYB >= containerOffsetBottom) winPosTop = cH - wH;

            // console.log(`ct:${containerOffsetTop}, cb:${containerOffsetBottom}, y:${scrollY}, yb:${scrollYB}, wpt: ${winPosTop}, wpb: ${winPosBottom}`);

            // 中心位置を計算
            centerX = (winPosLeft + winPosRight) / 2;
            centerY = (winPosTop + winPosBottom - containerOffsetTop*2) / 2;

            // 中心からの距離（20%の範囲）を計算
            rangeX = (winPosRight - winPosLeft) * range;
            rangeY = (winPosBottom - winPosTop) * range;
          } else {
            // 中心位置を計算
            centerX = cW / 2;
            centerY = cH / 2;

            // 中心からの距離（range%の範囲）を計算
            rangeX = centerX * range;
            rangeY = centerY * range;
          }

          // 最大数に達した時、古いものから消していく
          if (objects.length >= maxLabels) {
            container.removeChild(objects[0].el);
            objects.shift();
          }

          // シャッフルされた配列から順番にラベルを取得
          currentIndex = currentIndex + 1  // インデックスを更新
          if(currentIndex >= shuffledLabels.length) currentIndex = 0;
          
          let el = '';
          if(isLink == "false") {
            el = document.createElement('p');
          } else {
            el = document.createElement('a');
          }
          
          el.textContent = label.label;
          el.href = label.url;
          el.classList.add('bounce-text');

          if(isRandColor) {
            const r = intRandom(120,255);
            const g = intRandom(120,255);
            const b = intRandom(120,255);
            const randBgColor = `rgb(${r}, ${g}, ${b})`;
            el.style.backgroundColor = randBgColor;

            const brightness = Math.round(((r * 299) + (g * 587) + (b * 114)) / 1000);
            const randTextColor = (brightness > 125) ? 'black' : 'white';
            el.style.color = randTextColor;
          }

          if(textColor) {
            el.style.color = textColor;
            //el.style.borderColor = textColor;
            el.style.boxShadow = `0 0 4px ${textColor}`;
          }

          if(bgColor) {
            el.style.backgroundColor = bgColor;
          }

          // 要素を追加
          container.appendChild(el);

          // レイアウトの強制的な再計算を行い、正確な幅を取得
          el.offsetHeight; // reflow を強制
          const elWidth = el.clientWidth;

          // ラベルの位置をビューポートの中央付近にランダムに設定
          let x = (Math.random() * 2 - 1) * rangeX + centerX - elWidth/2;
          let y = (Math.random() * 2 - 1) * rangeY + centerY - el.clientHeight/2;

          // 初期位置を境界内に収める（既に宣言されているcWとcHを使用）
          x = Math.max(0, Math.min(x, cW - elWidth));
          y = Math.max(0, Math.min(y, cH - el.clientHeight));

          if(isLink !== "false") hoverDynamic(el);

          // スピードは一定にする
          const speed = Math.random() * (maxSpeed - minSpeed) + minSpeed;

          // 角度は水平または垂直を除く
          const angle = Math.random() * 2 * Math.PI;
          let dx = speed * Math.cos(angle);
          let dy = speed * Math.sin(angle);

          // 最小速度を保証（完全に水平・垂直を避ける）
          if (Math.abs(dx) < 0.5) dx = dx < 0 ? -0.5 : 0.5;
          if (Math.abs(dy) < 0.5) dy = dy < 0 ? -0.5 : 0.5;

          // オブジェクトに内部座標を保存
          const obj = { label, el, x, y, dx, dy };
          objects.push(obj);

          // 初期位置の設定
          obj.el.style.transform = `translate(${obj.x}px, ${obj.y}px)`;
        }

        function animate() {
          const cW = container.clientWidth;
          const cH = container.clientHeight;

          for (const obj of objects) {
            // 要素のサイズを取得
            const elWidth = obj.el.clientWidth;
            const elHeight = obj.el.clientHeight;

            // 境界チェックと跳ね返り処理
            if (obj.x + obj.dx < 0) {
              obj.dx = Math.abs(obj.dx);  // 右方向に強制
              obj.x = 0;  // 左端に固定
            } else if (obj.x + elWidth + obj.dx > cW) {
              obj.dx = -Math.abs(obj.dx);  // 左方向に強制
              obj.x = cW - elWidth;  // 右端に固定
            }

            if (obj.y + obj.dy < 0) {
              obj.dy = Math.abs(obj.dy);  // 下方向に強制
              obj.y = 0;  // 上端に固定
            } else if (obj.y + elHeight + obj.dy > cH) {
              obj.dy = -Math.abs(obj.dy);  // 上方向に強制
              obj.y = cH - elHeight;  // 下端に固定
            }

            // 最小速度を保証（ゼロベクトルと低速を防ぐ）
            const minVelocity = 0.5;
            if (Math.abs(obj.dx) < minVelocity) {
              obj.dx = obj.dx < 0 ? -minVelocity : minVelocity;
            }
            if (Math.abs(obj.dy) < minVelocity) {
              obj.dy = obj.dy < 0 ? -minVelocity : minVelocity;
            }

            // 座標を更新
            obj.x += obj.dx;
            obj.y += obj.dy;

            // 境界内に収める（安全確認）
            obj.x = Math.max(0, Math.min(obj.x, cW - elWidth));
            obj.y = Math.max(0, Math.min(obj.y, cH - elHeight));

            // transformを適用
            obj.el.style.transform = `translate(${obj.x}px, ${obj.y}px)`;
          }
          requestAnimationFrame(animate);
        }

        function init() {
          objects.forEach(obj => container.removeChild(obj.el));
          objects = [];
          shuffledLabels = shuffleArray(labels);
          currentIndex = 0;
          createObject();
        }
        
        setTimeout(() => {
          init();
          setInterval(() => {
            if(focus) {
              if(container.classList.contains('visible')) {
                createObject();
              } else {
                objects.forEach(obj => container.removeChild(obj.el));
                objects = [];
              }
            }
          }, showInterval);
          
          animate();
          let lastInnerWidth = window.innerWidth;
          window.addEventListener("resize", () => {
            if (lastInnerWidth != window.innerWidth) {
              init();
              lastInnerWidth = window.innerWidth;
            }
          });
  
          let focus = true;
          window.addEventListener('focus', () => {
            focus = true;
          });
          window.addEventListener('blur', () => {
            focus = false;
          });
        }, intRandom(100,2000))
      }
    })
  }
}